// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1Gy2T","Logo":"Toolbar_Logo__2kuhf","DesktopOnly":"Toolbar_DesktopOnly__1k5j5"};